import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <main className="not-found" id="main-content">
      <p className="not-found__eyebrow">404</p>
      <h1 className="not-found__title">This page has wandered off.</h1>
      <p className="not-found__copy">
        The piece or page you are looking for may have moved.
      </p>
      <div className="not-found__actions">
        <Link to="/shop">Shop all pieces</Link>
        <Link to="/">Return home</Link>
      </div>
    </main>
  );
}

export default NotFound;
